import React from 'react';
import {
	CUSTOMER_SERVICE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { ff } from '@atlassian/jira-feature-flagging';
import { APP_NAMES, toPackageName } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import { useIsJCS } from '@atlassian/jira-servicedesk-customer-service-common/src/utils/use-is-jcs';
import { FeatureVisibilityProvider } from '@atlassian/jira-servicedesk-itsm-features/src/controllers/feature-visibility-provider/index.tsx';
import ServiceDeskItsmFeatures from '@atlassian/jira-servicedesk-itsm-features/src/ui/index.tsx';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { useRouter } from '@atlassian/react-resource-router';

const jcsFeatures = {
	hasChannels: false,
	hasEssentials: false,
	hasPractices: false,
	hasOperations: false,
	hasLabs: false,
};

const ItsmFeatures = () => {
	const [{ match }] = useRouter();
	const isJCS = useIsJCS();
	const featureVisibilityProps = isJCS ? jcsFeatures : {};

	return ff('add-error-boundary-to-issue-type-package-components_2ds9q') ? (
		<UFOSegment name="itsm-features">
			<ProjectSettingsController projectKey={match.params.projectKey}>
				<JSErrorBoundary
					id={APP_NAMES.ITSM_FEATURES_SETTINGS}
					packageName={toPackageName(APP_NAMES.ITSM_FEATURES_SETTINGS)}
					teamName="jsd-shield"
					fallback="flag"
					attributes={{
						projectType: isJCS ? CUSTOMER_SERVICE_PROJECT : SERVICE_DESK_PROJECT,
					}}
				>
					<MarkProductStart />
					<FeatureVisibilityProvider {...featureVisibilityProps}>
						<ServiceDeskItsmFeatures />
					</FeatureVisibilityProvider>
				</JSErrorBoundary>
			</ProjectSettingsController>
		</UFOSegment>
	) : (
		<UFOSegment name="itsm-features">
			<ProjectSettingsController projectKey={match.params.projectKey}>
				<MarkProductStart />
				<FeatureVisibilityProvider {...featureVisibilityProps}>
					<ServiceDeskItsmFeatures />
				</FeatureVisibilityProvider>
			</ProjectSettingsController>
		</UFOSegment>
	);
};

export default ItsmFeatures;
